export var MuiListItemText = {
  styleOverrides: {
    primary: {
      ".MuiDrawer-root &": {
        fontWeight: 600
      }
    }
  }
};
//# sourceMappingURL=MuiListItemText.js.map